/** EN 15804 phase codes shown on the left of LCA flow sections (Lovable layout). */
export const LOVABLE_PHASE_BY_SECTION_ID = {
  a1: "A1",
  a2: "A2",
  a3: "A3",
  a36: "A4",
  a37: "A5",
  a41: "B1",
  a41_2: "B2",
  a41_3: "B3",
  a41_4: "B4",
  a41_5: "B5",
  c1: "C1",
  c1_transport: "C2",
  c1_waste: "C3",
  c1_disposal: "C4",
  c1_beyond: "D",
};

export const getLovablePhaseCode = (sectionId) =>
  LOVABLE_PHASE_BY_SECTION_ID[sectionId] ?? null;
